import React, { useState, useEffect } from "react";
import HorizontalBarOne from "./Charts/HorizontalBarOne";
import { Typography, Box, Button, CircularProgress } from "@mui/material";
import { useNavigate, useOutletContext } from "react-router-dom";
import config from "../../../config";

export default function DataHealthAndReliability() {

  // 🚀 Navigation hook (important)
  const navigate = useNavigate();
  const { selectedDateRange } = useOutletContext();
  const [syncData, setSyncData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSyncData();
  }, [selectedDateRange]);

  const fetchSyncData = async () => {
    try {
      setLoading(true);
      const baseUrl = config.API_BASE_URL_V1;
      let url = `${baseUrl}/analytics/data-health/product-sync`;

      // Add date filters if available
      if (selectedDateRange?.start_date && selectedDateRange?.end_date) {
        url += `?start_date=${selectedDateRange.start_date}&end_date=${selectedDateRange.end_date}`;
      }

      const response = await fetch(url, { headers: config.getHeaders() });
      const result = await response.json();
      setSyncData(result.data || []);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching sync data:", err);
    } finally {
      setLoading(false);
    }
  };

  const labels = syncData.map(item => item.organization_name);
  const syncCounts = syncData.map(item => item.sync_count);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            width: "fit-content",
            whiteSpace: "nowrap",
          }}
        >
          Product Sync Frequency
        </Typography>
      </Box>

      <Box
        sx={{
          p: 3,
          border: "1px solid #E5E7EB",
          borderRadius: "10px",
          background: "#fff",
          position: "relative",
        }}
      >
        {/* 🔹 View Details Button */}
        <Button
          variant="contained"
          sx={{
            position: "absolute",
            right: 20,
            top: 20,
            background: "#6A5BFF",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { background: "#5444ff" },
          }}
          onClick={() => {
            navigate("/analytics/data-health/details", { state: { selectedDateRange } });
          }}
        >
          View Details →
        </Button>

        <Typography sx={{ fontWeight: 500, mb: 2 }}>
          Monthly Sync Volume
        </Typography>

        {/* Loading state */}
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        )}

        {/* Error state */}
        {error && !loading && (
          <Typography sx={{ color: "red", py: 2 }}>
            Error loading sync data: {error}
          </Typography>
        )}

        {/* 🔹 Chart Component */}
        {!loading && !error && (
          <HorizontalBarOne
            labels={labels}
            latency={syncCounts}
            title="Sync Count"
          />
        )}
      </Box>
    </>
  );
}
